import { WarningAlert } from 'pivotal-ui/react/alerts'
import React from 'react'

export const HubInstallBanner = () => (
  <div className='mbxl'>
    <WarningAlert label='' withIcon>
      <strong>The next evolution of Tanzu is here</strong>
      <br />
      Install Tanzu Hub for a unified management experience. Contact your account team to get started.
    </WarningAlert>
  </div>
)
